module.exports = __webpack_public_path__ + "static/media/Dr Vikt uses Curoflow telemedicine software for digital healthcare.59c98708.webp";